var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"rotate"},[_c('RotateIcon',{staticClass:"rotate__icon"}),_c('Title',{staticClass:"rotate__title",attrs:{"text":_vm.translate('landscape.title')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }